module.exports = __webpack_public_path__ + "img/united1-cover-1.649dffeb.jpg";